import { DrawerProps } from 'antd/lib/drawer';
import { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { Drawer } from './drawer';
import { Header } from './header';

const StyledDrawer = styled(Drawer)`
  /* .ant-drawer-header {
    padding: 0;
  }

  .ant-drawer-close {
    display: flex;
    position: absolute;
    top: 0;
    right: 0;
  }
  .ant-drawer-body {
    padding: 0;
  } */
  .ant-drawer-header,
  .ant-drawer-header-no-title {
    position: absolute;
    width: 100%;
    background: transparent;
    border: none;
    padding: 0;
  }

  .ant-drawer-title {
    display: none;
  }

  .ant-drawer-close {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 10;
  }

  .ant-drawer-body {
    padding: 0;
  }
`;

const DrawerBody = styled.div`
  padding: var(--spacing-06);
`;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
declare const SubTitlePlacementTypes: ['bottom', 'top'];
declare type SubTitlePlacementType = (typeof SubTitlePlacementTypes)[number];

export interface OzoneDrawerProps extends Omit<DrawerProps, 'title'> {
  title?: string | ReactNode;
  subTitle?: string | ReactNode;
  showTaskColumn?: boolean;
  subTitleColor?: string;
  subTitlePlacement?: SubTitlePlacementType;
}

export const OzoneDrawer: FC<React.PropsWithChildren<OzoneDrawerProps>> = ({
  title,
  subTitle,
  children,
  subTitleColor,
  subTitlePlacement = 'bottom',
  headerStyle,
  ...rest
}) => (
  <StyledDrawer {...rest} title={null}>
    <Header
      title={title}
      subTitle={subTitle}
      subTitleColor={subTitleColor}
      subTitlePlacement={subTitlePlacement}
      headerStyle={headerStyle}
    />
    <DrawerBody className="drawer__body">{children}</DrawerBody>
  </StyledDrawer>
);
